import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Icon ionic-md-mail",
  "use": "icon-Icon ionic-md-mail-usage",
  "viewBox": "0 0 31.5 24.75",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31.5 24.75\" id=\"icon-Icon ionic-md-mail\"><defs><style>#icon-Icon ionic-md-mail .a{fill:#aab0bc;}</style></defs><path class=\"a\" d=\"M30.75,5.625H5.25a3.009,3.009,0,0,0-3,3v18.75a3.009,3.009,0,0,0,3,3h25.5a3.009,3.009,0,0,0,3-3V8.625A3.009,3.009,0,0,0,30.75,5.625ZM30.375,12,18,20.25,5.625,12V9L18,17.25,30.375,9Z\" transform=\"translate(-2.25 -5.625)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol